import React from 'react';
import { faFont } from '@fortawesome/pro-regular-svg-icons';
import DayNumberFields from 'components/actionBar/ActionBarCalendar/components/DayNumberFields';
import ToolBarColorPicker from 'components/actionBar/components/ToolbarColorPicker';
import Switch from 'components/common/Switch';
import c from '../CalendarGrid.module.scss';
import SettingsSection from '../SettingsSection';

/**
 * @param {Object} props
 * @param {import('actions/scene.types').CalendarShape} props.calendar Calendar shape being edited.
 * @param {import('actions/scene.types').CalendarShapeChangeHandler} props.onChange Applies a partial calendar update.
 * @returns {React.ReactElement}
 */
const DateNumbersSection = ({ calendar, onChange }) => {
  const useOtherMonthColor = calendar.useOtherMonthColor !== false;
  const useWeekendColor = calendar.useWeekendColor === true;

  return (
    <SettingsSection title="Date numbers">
      <DayNumberFields shape={calendar} onChange={onChange} className={c.typographyFields} />
      <div className={c.optionalColourSetting}>
        <Switch
          id="calendar-other-month-colour"
          checked={useOtherMonthColor}
          onChange={() => onChange({ useOtherMonthColor: !useOtherMonthColor })}
          label="Other month colour"
        />
        {useOtherMonthColor ? (
          <ToolBarColorPicker
            initialValue={calendar.otherMonthColor || calendar.secondaryColor || calendar.mainColor}
            onChange={(otherMonthColor) => onChange({ otherMonthColor })}
            icon={faFont}
          />
        ) : null}
      </div>
      <div className={c.optionalColourSetting}>
        <Switch
          id="calendar-weekend-colour"
          checked={useWeekendColor}
          onChange={() => onChange({ useWeekendColor: !useWeekendColor })}
          label="Weekend colour"
        />
        {useWeekendColor ? (
          <ToolBarColorPicker
            initialValue={calendar.weekendColor || calendar.mainColor}
            onChange={(weekendColor) => onChange({ weekendColor })}
            icon={faFont}
          />
        ) : null}
      </div>
      <div className={c.settingHint}>Applied in order: current month, other month, weekend.</div>
    </SettingsSection>
  );
};

export default DateNumbersSection;
